export const isOn = (state, { id }) => (state.ui.switches[id] ? state.ui.switches[id] : false);
export const isOpen = (state, { id }) => (state.ui.switches[id] ? state.ui.switches[id] : false);
export const getSwitch = (state, { id }) => state.ui.switches[id];
